module.exports = __webpack_public_path__ + "static/media/Verified_User.194a4d2d.svg";